<template>
  <div class="dish-list">
    <div class="dish-list-body">
      <div class="dish-list-box" id="list">
        <div
          class="dish-list-scroll"
          id="dishListScroll"
          v-if="!rearrange.active"
        >
          <div
            v-for="(product, index) in products"
            :key="`${product._id}-${index}`"
          >
            <div
              :class="{
                dish: true,
                currentDish:
                  !rearrange.active &&
                  !availability.active &&
                  index == currentDishIndex,
              }"
              @click="onDishSelect(index)"
            >
              <div class="dish-body">
                <div class="img-wrapper">
                  <img
                    :src="(product.image || product.image_thumbnail ? product.image_thumbnail || product.image : '/icons/no-dish.png')+`?nonce=${cache_nonce}`"
                  />
                </div>
                <div class="dish-info">
                  <h3
                    :class="{
                      'not-translated':
                        isLocalizing && isUiMenuTranslationPreviewed && !findProductLocaleContext(product).name,
                    }"
                  >
                    {{ getProductDisplayName(product) }}
                  </h3>

                  <p
                    :class="
                      product.name.length <= 20
                        ? 'desc-out-of-stock'
                        : 'desc-out-of-stock down'
                    "
                    v-if="validateDish(product) && !isInStock(product)"
                  >
                    {{ $t("dish_list.out_of_stock") }}
                  </p>
                  <p
                    :class="
                      product.name.length <= 20
                        ? 'desc-out-of-stock'
                        : 'desc-out-of-stock down'
                    "
                    v-else-if="!validateDish(product)"
                  >
                    {{ $t("dish_list.invalid_dish") }}
                  </p>
                  <!-- <p v-else>{{ product.description }}</p> -->
                  <span
                    :class="currentDishIndex == index ? 'num active' : 'num'"
                    >{{ index + 1 }}</span
                  >
                  <div
                    class="system-circle preorder"
                    v-if="menuModes.preorder && product.enabled_modes.preorder"
                  ></div>
                  <div
                    class="system-circle inside"
                    v-if="menuModes.inside && product.enabled_modes.inside"
                  ></div>
                  <div
                    class="system-circle delivery"
                    v-if="menuModes.delivery && product.enabled_modes.delivery"
                  ></div>
                </div>
              </div>

              <div
                :class="{
                  'dish-availability-toggle': true,
                  'dish-availability-toggle-active': product.stock,
                }"
                @click="product.stock = !product.stock"
                v-if="availability.active"
              ></div>
            </div>
          </div>
        </div>

        <div class="dish-list-box" v-if="rearrange.active">
          <div class="dish-list" id="list" :style="{ 'padding-bottom': '0vw' }">
            <draggable
              :value="products"
              @change="onRearrangeChange"
              ghost-class="rearrange-ghost"
              v-if="rearrange.active"
            >
              <div
                v-for="(product, index) in products"
                :key="`${product._id}-${index}`"
              >
                <div
                  :class="{
                    dish: true,
                  }"
                  @click="onDishSelect(index)"
                >
                  <div class="dish-body">
                    <div class="img-wrapper">
                      <img
                        :src="
                          product.image ? product.image : '/icons/no-dish.png'
                        "
                      />
                    </div>
                    <div class="dish-info">
                      <h3>{{ product.name }}</h3>
                      <!-- <p>{{ product.description }}</p> -->
                    </div>
                  </div>
                  <div v-if="!rearrange.active" class="dish-number">
                    {{ index + 1 }}
                  </div>

                  <div class="tabs v1-grey-2-color" v-if="rearrange.active">
                    <BaseIcon icon="list" size="lg" />
                  </div>
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </div>
    </div>
    <div
      class="buttons-row mt-16"
      v-if="
        !rearrange.active && !availability.active && !busy && !isExampleMenu
      "
    >
      <BaseButton
        variant="secondary"
        class="mr-8"
        @click="deleting = true"
        icon="trash"
        color="red-4"
        size="md"
        v-if="dish"
      />
      <BaseButton
        variant="secondary"
        @click="transfer_modal = true"
        class="mr-8"
        icon="move-filled"
        size="md"
        v-if="dish"
      />
      <BaseButton
        variant="secondary"
        class="mr-8"
        icon="list"
        size="md"
        @click="
          rearrange.active = true;
          $emit('rearrange');
        "
        v-if="dish"
      />
      <BaseButton
        variant="secondary"
        class="mr-8"
        @click="duplicateDish"
        icon="copy"
        size="md"
        v-if="dish"
      />
      <BaseButton
        variant="secondary"
        class="mr-8"
        @click="toggleExclusive"
        :icon="dish.is_exclusive ? 'star-01-filled' : 'star-01'"
        size="md"
        v-if="dish"
      />
      <BaseButton
        variant="secondary"
        class="w-100"
        icon="plus"
        color="green-6"
        size="md"
        @click="showAddDishUI"
        v-if="!rearrange.active && !availability.active && !exclusives_category"
      />
    </div>

    <p class="rearrange-buttons" v-if="rearrange.active || availability.active">
      <BaseButton
        size="md"
        color="green-6"
        variant="primary"
        class="w-100"
        @click="onFinishAction"
      >
        {{ $t("category_list.done") }}
      </BaseButton>
    </p>

    <DangerConfirmModal
      @cancel="deleting = false"
      @confirm="onDelete"
      :title="$t('dish_tab.confirm_delete_title')"
      v-if="deleting"
      ><p class="qrw-paragraph-md v1-grey-3-color">
        {{
          $t("dish_tab.confirm_delete", {
            name: dish.name,
          })
        }}
      </p></DangerConfirmModal
    >

    <TransferDishModal
      @close="transfer_modal = false"
      @transfered="onDishTransfered"
      v-if="transfer_modal"
    />
  </div>
</template>

<script>
import draggable from "vuedraggable";

import TransferDishModal from "@/components/menu/TransferDishModal.vue";

export default {
  data() {
    return {
      // currentDishIndex: null,

      rearrange: {
        active: false,
      },

      availability: {
        active: false,
      },

      transfer_modal: false,
      deleting: false,

      cache_nonce: 1
    };
  },
  props: {
    category: Object,
    busy: Boolean,
  },
  watch: {
    category() {
      if (this.products.length) this.onDishSelect(0);
    },
    currentDishIndex: {
      handler() {
        if (this.currentDishIndex == this.products.length - 1) {
          this.scrollList();
        }
      },
      deep: true,
    },
    exclusives_category() {
      if (this.exclusives_category) this.onDishSelect(0);
    },
  },
  components: {
    draggable,
    TransferDishModal,
  },
  methods: {
    updateImageNonces() {
      this.cache_nonce = Date.now();
    },
    onDishSelect(index) {
      // this.currentDishIndex = index;
      this.$emit("select", this.products[index]);
      // this.$emit("select", dish);
    },
    scrollList() {
      const scrollContainer = document.getElementById("list");

      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    },
    showAddDishUI() {
      this.$store.dispatch("menu/createEmptyProduct", {
        category: this.category,
      });

      this.$nextTick(this.scrollList);
      // this.currentDishIndex = this.products.length - 1;
      this.$nextTick(() => {
        this.$emit("edit");
        window.document.getElementById("dishListScroll").scrollTop =
          window.document.getElementById("dishListScroll").scrollHeight;
      });
    },
    showAvailabilityUI() {
      this.availability.active = true;
    },
    duplicateDish() {
      this.$store.dispatch("menu/duplicateProduct", {
        suffix: this.$t("menu_settings.duplicate_suffix"),
      });
    },
    onFinishAction() {
      if (this.availability.active) {
        this.availability.active = false;
      }

      if (this.rearrange.active) {
        this.rearrange.active = false;
      }

      this.$store.dispatch("menu/save");
    },
    toggleExclusive() {
      this.$store.commit("menu/toggleExclusive", this.dish);
      this.$store.dispatch("menu/updateProduct");
    },
    onDelete() {
      this.deleting = false;

      const auditlog_entry = {
        menu_id: this.$store.state.menu.current._id,
        menu_title: this.$store.state.menu.current.title,
        product_id: this.dish._id,
        name: this.dish.name,
        category: this.dish.category,
      };

      // this.$store.commit("menu/removeProduct", this.dish);
      // this.$store.commit("menu/chooseProduct", null);
      // this.$store.dispatch("menu/save");
      this.$store.dispatch("menu/removeProduct").then(() => {
        this.$store.dispatch("auditlog/write", {
          type: "remove_menu_product",
          payload: auditlog_entry,
        });

        if (this.category) {
          const other_products = this.$store.getters[
            "menu/productsForCategory"
          ](this.category);

          if (other_products.length) {
            this.$store.commit("menu/chooseProduct", other_products[0]);
          } else {
            this.$store.commit("menu/chooseProduct", null);
          }
        } else {
          this.$store.commit("menu/chooseProduct", null);
        }
      });

      // this.$emit('finishEdit');
    },
    onRearrangeChange(ev) {
      if (ev.moved) {
        const first = ev.moved.oldIndex;
        const second = ev.moved.newIndex;

        this.$store.commit("menu/rearrangeDishes", {
          first: this.products[first]._id,
          second: this.products[second]._id,
        });
      }
    },
    findProductLocaleContext(product) {
      return product.i18n.find(
        (item) => item.locale == this.$store.state.menu.current_locale
      );
    },
    validateDish(dish) {
      return this.$store.getters["menu/isDishObjectValid"](dish);
    },
    isInStock(dish) {
      return (
        !this.$store.getters["stoplist/isProductStoplisted"](
          this.$store.state.menu.current._id,
          dish._id
        ) && dish.stock
      );
    },
    getProductDisplayName(product) {
      if (!this.isLocalizing) return product.name;

      const ctx = this.findProductLocaleContext(product);

      if (ctx) {
        return ctx.name || product.name;
      } else {
        return product.name;
      }
    },
  },

  mounted() {
    if (this.products.length && !this.$route.query.product_id) {
      this.onDishSelect(0);
    }
  },
  computed: {
    currentDishIndex() {
      return this.products.indexOf(this.currentDish);
    },
    isLocalizing() {
      return this.$store.getters["menu/isLocalizing"];
    },
    currentProductLocaleIndex() {
      return this.$store.getters["menu/currentProductLocaleIndex"];
    },
    isExampleMenu() {
      return this.$store.state.menu.current.is_example;
    },
    currentProductLocale() {
      return this.$store.getters["menu/currentProductLocale"];
    },
    products() {
      if (this.exclusives_category)
        return this.$store.getters["menu/exclusivesList"];
      return this.$store.getters["menu/productsForCategory"](this.category);
    },
    exclusives_category() {
      return this.$store.state.menu.exclusives_category;
    },
    currentDish() {
      return this.dish;
      // return this.products[this.currentDishIndex];
    },
    dish() {
      return this.$store.state.menu.product;
    },
    menuModes() {
      return this.$store.getters["menu/menuModes"]();
    },
    isUiMenuTranslationPreviewed() {
      return this.$store.state.menu.ui_translation_preview;
    },
  },
};
</script>

<style scoped>
.buttons-row {
  display: flex;
}

.dish-list {
  width: 100%;
  display: block;
}
.dish-list-title {
  font-weight: 500;
  font-size: 3vh;
  color: #a4a3a2;
  margin-bottom: 0;
}
.dish-list-border {
  position: relative;
}
.big-btn {
  width: 92%;
}
.dish-list-box {
  overflow-y: auto;
  overflow-x: hidden;
  height: 56vh;
  background: #1d1d1b;
  border-radius: 8px;
}

.dish-list-scroll {
  background: #1d1d1b;
}

button.range {
  background: transparent url(../../assets/rerange.svg) no-repeat center left;
  background-size: 2vh;
  color: #129b81 !important;
  margin-right: 1.2vh;
  background-position-x: 1vh;
  padding-left: 4.5vh !important;
  border-radius: 0.5vh;
  border: 1px solid #129b81;
  width: auto;
}

.range:hover {
  background: #129b81 url(../../assets/rerange-black.svg) no-repeat center left;
  background-size: 2vh !important;
  background-position-x: 1vh !important;
  color: #1d1d1d !important;
}

.system-circle {
  height: 0.8vh;
  width: 0.8vh;
  position: relative;
  margin: 0.5vh 0 0 auto;
  border-radius: 5vh;
  right: 0.5vh;
  top: 0.5vh;
}

.system-circle.preorder {
  background: #ffd2a8;
}
.system-circle.inside {
  background: #aeccc6;
}
.system-circle.delivery {
  background: #cbd9e6;
}

.num {
  font-size: 7vh;
  color: #363636;
  line-height: initial;
  position: absolute;
  right: 1.2vh;
  top: 0;
}

.num.active {
  color: #107764;
}

.dish-add button:hover {
  color: #000;
  background: #cbd9e6;
}

.dish-list-body {
  position: relative;
}

.dish-body {
  display: flex;
  align-items: center;
}

.dish-body.range {
  background: #129b81;
  width: 100%;
  position: relative;
  height: 100%;
}

.img-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  height: 8.6vh;
  background: rgb(29, 29, 27);
}

.dish-body img {
  width: 15.6vh;
  opacity: 0.3;
  height: 100%;
  object-fit: cover;
}

.dish-info h3 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 85%;
  height: 4.8vh;
  font-weight: 500;
  font-size: 1.7vh;
  line-height: 100%;
  position: absolute;
  padding: 1.4vh 3vh 0;
  top: 0;
  left: 0;
  margin-bottom: 0;
  color: #ededed !important;
}

.dish-info p {
  width: 22vh;

  font-weight: 500;
  font-size: 1.1vh;
  line-height: 130.8%;
  color: #a4a3a1;
  margin: 0;
  padding-top: 2vh;
  height: 6.2vh;
  overflow: hidden;
  display: block;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.currentDish {
  background: #129b81;
}
.currentDish div p {
  color: #a4a3a1;
}
.currentDish div h3 {
  color: #1d1d1b;
}

.dish-number {
  position: absolute;
  right: 2.2vh;
  top: 3.5vh;
  width: 3vh;
  height: 3vh;
  background: #464646;
  border-radius: 5vh;

  font-weight: 500;
  font-size: 2.2vh;
  display: flex;
  align-items: center;

  justify-content: center;
  color: #ededed;
}

.tabs {
  position: absolute;
  top: 16px;

  right: 8px;
}

.dish-btn {
  display: flex;
  margin-top: 2.2vh;
}

.rearrange {
  width: 10vw;
  height: 2.8vw;

  border: 0.06vw solid #a4a3a1;
  box-sizing: border-box;
  border-radius: 1.4vw;
  background: #464646;
  color: #fff;
  font-weight: 500;
  font-size: 1.33vw;
  /* line-height: 23px; */
  display: flex;
  justify-content: center;

  color: #a4a3a1;

  cursor: pointer;
  margin-top: 3.5vh;
}

.dish-list-editor {
  position: relative;
  background: #5f5f5f;
}
.dish-info-edit {
  padding-left: 0.53vw;
  padding-right: 0.53vw;
}
.dish-info-edit div {
  display: flex;
}

.dish-price-edit,
.dish-title-edit {
  background: #ffffff;
  border-radius: 0.4vw;
  border: 0;
  padding-left: 0.8vw;
  outline: none;
}

.dish-price-edit {
  text-align: center;
  padding: 0;
}

.dish-desc-edit {
  width: 21vw;
  height: 5.3vw;

  background: #ffffff;
  border-radius: 0.4vw;

  font-size: 1.06vw;
  line-height: 130.8%;

  color: #464646;

  border: 0;

  margin-top: 0.53vw;
  outline: none;
  padding-left: 0.66vw;
}

.dish-price-edit {
  width: 5.06vw;
  height: 2.466vw;
  margin-left: 2.13vw;

  font-weight: 500;
  font-size: 2vw;
  /* line-height: 35px; */

  color: #000000;
}
.dish-title-edit {
  width: 14vw;
  height: 2.46vw;

  font-weight: bold;
  font-size: 1.33vw;
  /* line-height: 23px; */

  color: #000000;
}

.done {
  border: 1px solid #129b81;
  color: #129b81;
}
.done:hover {
  color: #ededed !important;
}
.rearrange-buttons {
  margin-top: 16px;
  outline: none;

  display: flex;
  justify-content: center;
}

.dish-list-editor img {
  width: 110%;
  position: relative;
  left: -0.3vw;
  /* filter: blur(4px); */

  width: 22.666vw;
  height: 14.2vw;
  margin-bottom: 2vw;
}

.dish-list-editor button {
  position: absolute;
  top: 5.66vw;
  left: 6.46vw;

  border: 0;
  color: #fff;
  padding: 0.73vw;
  padding-left: 2.8vw;
  border-radius: 0.8vw;

  font-weight: bold;
  font-size: 1.33vw;
  /* line-height: 23px; */
  cursor: pointer;

  background: url("/change.png") 13px no-repeat;
  background-color: #464646;
  background-size: 1.66vw;
}

.dish {
  position: relative;
  height: 8.6vh;
  transition: 0.1s;
  cursor: pointer;
}

.addition {
  margin-top: 1.33vw;
  display: block !important;
  margin-left: 0.8vw;
  margin-right: 0.8vw;
}
.addition h3 {
  font-weight: 500;
  font-size: 1.066vw;
  /* line-height: 19px; */
  color: #ffffff;
}
.addition-body {
  display: flex;
}

.dish-availability-toggle {
  border-radius: 50%;
  border: 0.3vh solid #1d1d1b;

  display: flex;
  align-items: center;

  justify-content: center;

  position: absolute;
  right: 2.2vh;
  top: 3.3vh;
  width: 3.5vh;
  height: 3.5vh;
  background-color: #a4a3a1;
}

.dish-availability-toggle-active {
  background-color: #129b81;
}

.rearrange-ghost {
  background: #cbd9e6;
}
.rearrange-ghost div p {
  color: #a4a3a1;
}

.dish-info {
  position: relative;
  height: 8.7vh;
  width: 100%;
}

.desc-out-of-stock {
  color: #e2223b !important;
  position: absolute;
  line-height: 1 !important;
  font-size: 1.4vh !important;
  padding: 0 3.2vh !important;
  height: auto !important;
  bottom: 2vh;
}

.desc-out-of-stock.down {
  bottom: 0.8vh;
}

.dish-info h3.not-translated {
  color: #e2223b !important;
}
</style>
